import {
  Box,
  type BoxProps,
  TextInput,
  type TextInputProps,
} from '@mantine/core'
import { clsx } from 'clsx'
import React from 'react'

import { DropdownCountries } from './DropdownCountries'
import styles from './styles.module.css'

export type InputPhoneNumberProps = BoxProps &
  TextInputProps & {
    valueDialCode?: string
    defaultValueDialCode?: string
    onChangeDialCode?: (dialCode: string) => void
  }

export function InputPhoneNumber({
  className,
  valueDialCode,
  defaultValueDialCode,
  onChangeDialCode,
  ...props
}: InputPhoneNumberProps) {
  return (
    <TextInput
      className={clsx(styles.input, className)}
      {...props}
      data-testid='input-phone'
      inputContainer={(children) => (
        <Box className={styles.wrapper}>
          <DropdownCountries
            size={props.size}
            valueDialCode={valueDialCode}
            defaultValueDialCode={defaultValueDialCode}
            onChangeDialCode={(dialCode) => onChangeDialCode?.(dialCode)}
            data-testid='dropdown-countries'
          />
          {children}
        </Box>
      )}
    />
  )
}
